import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import DotsLoading from '../ui/DotsLoading';
import { getOffersAccordionData } from '../../services/offers';
import OfferTimelines from './OfferTimelines';
import { DollarSign, TrendingUp, Clock, CheckCircle, RefreshCw } from 'lucide-react';
import OfferStats from './OfferStats';

const Wrapper = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const SectionHeader = styled.div`
  margin-bottom: 16px;
  
  @media (max-width: 768px) {
    margin-bottom: 12px;
  }
  
  @media (max-width: 480px) {
    margin-bottom: 10px;
  }
  
  h2 {
    color: rgba(255, 255, 255, 0.50);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
    text-transform: uppercase;
    margin: 0;
  }
`;

const ErrorMessage = styled.div`
  color: #F43F60;
  text-align: center;
  margin: 40px 0;
  font-size: 1rem;
  
  @media (max-width: 768px) {
    margin: 32px 0;
  }
  
  @media (max-width: 480px) {
    margin: 24px 0;
  }
`;

const OfferTimelinesContainer = () => {
    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [stats, setStats] = useState({
        totalOffers: 0,
        totalValue: 0,
        acceptedOffers: 0,
        pendingOffers: 0,
        counteredOffers: 0,
        averageOfferValue: 0
    });

    useEffect(() => {
        const fetchOffers = async () => {
            setLoading(true);
            setError('');
            try {
                const result = await getOffersAccordionData();
                if (result?.status === 'success') {
                    const offersData = result?.data || [];
                    setOffers(offersData);

                    // Calculate statistics
                    const totalOffers = offersData.length;
                    const totalValue = offersData.reduce((sum, offer) => sum + (parseFloat(offer.amount) || 0), 0);
                    const acceptedOffers = offersData.filter(offer => offer.status === 'accepted').length;
                    const pendingOffers = offersData.filter(offer => offer.status === 'pending').length;
                    const counteredOffers = offersData.filter(offer => offer.status === 'countered').length;
                    const averageOfferValue = totalOffers > 0 ? totalValue / totalOffers : 0;
                  console.log(totalValue)
                    setStats({
                        totalOffers,
                        totalValue,
                        acceptedOffers,
                        pendingOffers,
                        counteredOffers,
                        averageOfferValue
                    });
                } else {
                    setError(result?.message || 'Failed to fetch offers');
                }
            } catch (err) {
                console.log(err);
                setError('Failed to fetch offers');
            } finally {
                setLoading(false);
            }
        };
        fetchOffers();
    }, []);

    return (
        <Wrapper>
            {!loading && !error && <Section>
                <SectionHeader>
                    <h2>Offer Statistics</h2>
                </SectionHeader>
                <OfferStats stats={stats} />
            </Section>}

            {loading ? (
                <DotsLoading />
            ) : error ? (
                <ErrorMessage>{error}</ErrorMessage>
            ) : (
                <OfferTimelines offers={offers} />
            )}
        </Wrapper>
    );
};

export default OfferTimelinesContainer;
